import React from 'react';
import { Section as SectionDI, SkeletonItem as SkeletonItemDI } from '@atlaskit/side-navigation';
import { useIntlV2 as useIntlDI } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { MenuItem as MenuItemDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useProject as useProjectDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { withThrowOnError } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/throw-when-no-data-and-error/index.tsx';
import { matchUrlParams as matchUrlParamsDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { useReports as useReportsDI } from '../../../../controllers/reports/index.tsx';
import { messages } from './messages.tsx';
import type { ForecastManagementReportsProps } from './types.tsx';

const useThrowProjectDI = withThrowOnError(useProjectDI);
const useThrowReportsDI = withThrowOnError(useReportsDI);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({
	MenuItem = MenuItemDI,
	Section = SectionDI,
	SkeletonItem = SkeletonItemDI,
	useIntl = useIntlDI,
	useProject = useThrowProjectDI,
	useReports = useThrowReportsDI,
	matchUrlParams = matchUrlParamsDI,
}: ForecastManagementReportsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();
	const { data: reports } = useReports();

	if (project == null || reports == null) return <SkeletonItem />;

	const baseReportUrl = `/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}`;

	return (
		<Section title={formatMessage(messages.forecastManagement)}>
			{reports.hasTimeTrackingReport && (
				<MenuItem
					analytics={{ itemId: 'time-tracking' }}
					selectedOn={matchUrlParams(['reportKey'])}
					href={`${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:time-tracking`}
				>
					{formatMessage(messages.timeTrackingReport)}
				</MenuItem>
			)}
			{reports.hasUserWorkloadReport && (
				<MenuItem
					analytics={{ itemId: 'developer-workload' }}
					selectedOn={matchUrlParams(['reportKey'])}
					href={`${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:developer-workload`}
				>
					{formatMessage(messages.userWorkloadReport)}
				</MenuItem>
			)}
			{reports.hasVersionWorkloadReport && (
				<MenuItem
					analytics={{ itemId: 'version-workload' }}
					selectedOn={matchUrlParams(['reportKey'])}
					href={`${baseReportUrl}&reportKey=com.atlassian.jira.plugins.jira-software-plugin:version-workload-report`}
				>
					{formatMessage(messages.versionWorkloadReport)}
				</MenuItem>
			)}
		</Section>
	);
};
